import { Link } from "react-router-dom";

export default function FAQ() {
  return (
    <div className="faq">
      <h1>FAQ</h1>
      <div className="questions">
        <div className="section">
          <h1 className="q">How do I get started/get money</h1>
          <p className="a">
            There are many ways to get some money, head to one of the blips on
            the map like pizza delivery or postal ops, or even one of the player
            ran businesses (or do some crime)
          </p>
        </div>
        <div className="section">
          <h1 className="q">How do I become a cop</h1>
          <p className="a">
            Head to <Link to="/applications">the applications page</Link>, go to
            the cop application form (or any other position), fill them out and
            DM or ping the chief of police in the server so they can check
          </p>
        </div>
        <div className="section">
          <h1 className="q">How do I report bugs/give feedback</h1>
          <p className="a">
            Head to{" "}
            <Link
              to="https://dsc.gg/tropicalroleplay"
              target="_blank"
              rel="noopener"
            >
              our Discord server
            </Link>{" "}
            and create a post in{" "}
            <Link
              to="https://discord.com/channels/1118270271103709194/1173063162275299399"
              rel="noopener"
              target="_blank"
            >
              #bug-reports
            </Link>{" "}
            to report bugs or{" "}
            <Link
              to="https://discord.com/channels/1118270271103709194/1173061519559360522"
              target="_blank"
              rel="noopener"
            >
              #suggestions
            </Link>{" "}
            to give feedback
          </p>
        </div>
      </div>
    </div>
  );
}
